import { AppliedCampaignsFilters, CampaignFilter } from 'store/models/campaignsFilters';

export const getAppliedCampaignsFiltersTotalCount = (appliedCampaignsFilters: AppliedCampaignsFilters): number => {
    return Object.values(appliedCampaignsFilters).reduce(
        (acc: number, filter: Set<string>) => acc + filter.size,
        0
    ) as number;
};

export const OVERLY_MASSIVE_FILTERS: CampaignFilter[] = [
    CampaignFilter.Areas,
    CampaignFilter.ProfessionalRoles,
    CampaignFilter.CreatedByUserIds,
];
export const MAX_CHECKBOX_SHOWN_COUNT = 6;

const MIN_CHECKBOX_COUNT_TO_SHOW_FILTER = 1;

export const needToShowFilter = (filterName: string, filterList: Record<string, string>): boolean => {
    const filterListLength = Object.keys(filterList).length;
    return (
        filterListLength > MIN_CHECKBOX_COUNT_TO_SHOW_FILTER ||
        ([CampaignFilter.CampaignStatuses, CampaignFilter.BudgetStatuses, CampaignFilter.ModerationStatuses].includes(
            filterName as CampaignFilter
        ) &&
            filterListLength > 0)
    );
};
